<template>
    <div>
        <h2 class="post__title text-center">如何成为一个坚强的人：心理韧性强大人群的三个秘密</h2>
        <h3 class="post__meta text-center">by <router-link class="post__author"
          :to="`/home/team`">{{ author }}</router-link>
           	- <time>{{ prettyDate(published) }}</time>
        </h3>
        <section class="post__body rte">我很想来分享这场2019年Lucy Hone博士做的TED演讲 《心理韧性强大人群的三个秘密》(The Three Secrets of Resilient People)。Lucy博士是一位研究心理韧性的专家，她原先认为自己的使命是帮助受2011年基督城地震影响的人群恢复心理健康，度过难关。但在2014 Lucy 12岁的女儿Abi因一场严重车祸当场去世。女儿突然的去世，让Lucy瞬间从一个帮助他人的心理专家变成需要受助的悲伤母亲。一开始她对这个角色转变很不适应，他人的专业帮助使她更加的伤心无助，甚至生气。后来她想到，自己是研究心理韧性的专家，她好奇自己是否可以用专业知识来为自己解忧。女儿去世的五年后，Lucy从自己的经历中总结了如何加强心理韧性的主要三点。</section>
        <h2 class="post__title text-left">第一</h2>
        <section class="post__body rte">Lucy说要加强韧性就要能接受痛苦是你生命中的一部分。当苦难来临的时候也许你会觉得很倒霉，为什么会发生在我身上呢？但真实的生活不是在社交网站上展现出来的光彩亮丽，痛苦与不幸是每个人生活中必要的一部分。</section>
        <section class="post__body rte"><strong class="highlight">我的想法是:</strong> 我们对待苦难要向对待一个不受欢迎的朋友的突然来访。你非常不欢迎ta的来到，但你可以接受ta的存在和给你带来的不便。另外就是对生命中机率的理解。我的理解是生命中很多事情的发生我们是躲不过也没有选择的。一般我们在买彩票的时候，希望极小赢彩票的机率能站在我们一边，但同时我们也希望发生不幸事件的机率离我们远远的。残酷的现实是，我们无法去控制生命中的机率，但我们可以勇敢的接受，这也是心理复原的第一步。比如，我在工作中经常遇到客人因为焦虑的问题来找我咨询。大多数人会问到： “为什么我以前一直睡得着吃得香，但最近状态那么差？” 客人经常会因为不接受自己现在的焦虑，反而更加的自卑愧疚，为当今不理想的生活工作状态而更焦虑。为焦虑而焦虑是很普遍的现象。但只有当我们开始接受自己的焦虑，以及焦虑带来的身体心理上的不良反应，我们的状态才能慢慢改进。这是心理疏导中很重要的一个开端。我们能否把焦虑看作一个不受欢迎的老朋友来到访呢? “噢,你来了! 你等一下，我有办法来面对你“。</section>
        
        <img class="mx-auto d-block col-md-2" src="@/assets/images/boxes.jpg" alt="image"/>
        <section class="mx-auto d-block col-md-2 topbit">老朋友你来了! 我有办法来面对你。</section>


        <h2 class="post__title text-left">第二</h2>
        <section class="post__body rte">Lucy说到要加强心理韧性，第二点是要学会关注生命中阳光积极的方面。科学证明，越会感恩的人离忧郁越远。当你觉得整个世界都塌下来毫无希望的时候，感恩尤其重要。Lucy分享了她家厨房墙壁上挂着一块亮粉色的板，上面写着他们各种大大小小的感恩，每天提醒全家 ---- 日子再艰难还是有值得感恩的地方。</section>
        <section class="post__body rte"><strong class="highlight">我的做法:</strong> 我的办公桌上有一个空瓶子，我不时的会在瓶子里投小纸条用来记录我当天的感恩或为自己自豪的事。因为工作中接触太多的负面情绪和事物，同事们也都忙得焦头烂额，互相关心的机会很有限，有时难免会情绪低落，觉得无人关心鼓励自己。所以我能为自己做的是，经常积累小小的感恩和对自己的鼓励。比如我今天给自己的纸条是：我不喜欢在开会的时候发言，但今天我很勇敢的大声说出自己的观点，我为自己骄傲！</section>
        
        <!-- <img class="mx-auto d-block col-md-2" src="@/assets/images/jar.jpg" alt="image"/>
        <section class="mx-auto d-block col-md-2 topbit">我办公桌上的瓶子。 </section> -->

      <div class="row">
        <div class="col-md-2">
        <img class="mx-auto d-block" src="@/assets/images/jar.jpg" alt="image"/>
        <section class="mx-auto d-block topbit">我办公桌上的瓶子。 </section>
        </div>
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/family.jpg" alt="image"/>
        <section class="mx-auto d-block topbit">日子再艰难还是有值得感恩的地方。</section>
        </div>
      </div>

        <!-- <div class="col-md-4">
        <img class="mx-auto d-block col-md-2" src="@/assets/images/jar.jpg" alt="image"/>
        </div> -->

        <h2 class="post__title text-left">第三</h2>
        <section class="post__body rte">Lucy说到加强心理韧性的第三点是，要学会经常问自己一个问题： “我要做的事，是对我有益还是有害？”  Lucy同时指出，这也是心理治疗中很有效的一个方法。当我们经历痛苦的时候，会时常觉得我们是被动的受害者，因此毫无选择。但当你问自己这个问题的时候，主动权又回到了你手中。</section>
        <section class="post__body rte"><strong class="highlight">我的想法:</strong> 我回想到自己曾经的一段艰难时期。那时我觉得自己的痛苦是没有截止日期的，整个世界都是黑暗一片，而我就是孤独一人。有朋友提醒我眼光要放短浅一点不要看那么远，艰难时期的日子要一小时或一天天的过。抱着死马当活马医的心情，我开始学习如何看着眼前的事物一点点的面对。因此我突然有了生活中的主动权，至少我可以面对一些不起眼的小事了。比如今天好伤心，与其什么都不做沉浸在伤感中，我可以买一些好吃的来安抚自己，或者大哭一场哭到爽快。我慢慢开始学会了为自己提供一些健康的情绪发泄方式。我认为当我们学会在小事上为自己做出有益的选择，我们才更有可能在大事中做出明智的决定。</section>
        
        <img class="mx-auto d-block col-md-4" src="@/assets/images/choice.jpg" alt="image"/>
        <section class="mx-auto d-block col-md-4 topbit">山穷水尽之时，不要忘了你还是有选择的。</section>

        <section class="post__body rte">最后Lucy说能做到上述三点并不容易，但每个人都有能力做到。虽然做到这三点之后你的悲痛不会完全消失，但你的心理韧性会加强，恭喜你成为了一个更坚强的自己。</section>
        
        <section class="post__body rte"><strong class="highlight">My final thoughts:</strong> 看完Lucy的演讲，我首先钦佩Lucy的韧性。孩子突然去世带来的痛苦是如此的巨大，Lucy不仅依靠着自己专业的心理知识和经验一步步走出最黑暗的日子，而且还愿意与他人分享这艰苦的历程，我实在是佩服。其次我被她的真诚和勇敢感动。Lucy没有刻意隐藏悲伤，也没有试图表达完全走出了悲痛。她的声音和表情里时刻充满了失去女儿的痛，但她还是坚强的站在台上讲出自己的经历。我想Abi在天堂一定会为Lucy感到骄傲的。让我印象最深的是，当她说到 “it is possible to live and grieve at the same time” – 悲伤与生活是可以共存的。真正勇敢的人才会去面对这个事实，不是吗？</section>
        <section class="post__body rte">这篇观后感不仅是分享也是自我提醒。谢谢阅读。想看Lucy博士的演讲, 请点击视频链接 <a href="https://www.youtube.com/watch?v=NWH8N-BvhAw">https://www.youtube.com/watch?v=NWH8N-BvhAw</a></section>


        <div class="row mx-auto col-md-6">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/yi_2021.jpg" alt="image"/>
        </div>
        <div class="col-md-6">
          <section class="post__body rte">张艺 – 新西兰注册心理师</section>
          <section class="post__body rte">New Zealand Registered Psychologist</section>
          <section class="post__body rte"><a href="https://www.reachingpotential.co.nz">reachingpotential.co.nz</a></section>
            <img class="col-md-5" src="@/assets/images/yi_weechat.jpg" alt="image"/>
            <section class="post__body rte">微信号：YZNZ2013</section>
        </div>
      </div>
    </div>
</template>

<script>
import { kebabify, prettyDate } from '../helpers'
export default
{
  data() {
    return {
      author: 'Yi Zhang',
      published: '2021-02-26T18:17:00Z'
    }
  },
    methods: {
        kebabify,
        prettyDate
    }
}
</script>

<style>
@media (min-width: 768px ) {
  .row {
      position: relative;
      padding: 1.25rem 1.25rem 1rem;
  }

  .bottom-align-text {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.list-with-bullets li::before {
  padding: 0.25rem 1.25rem 0rem;
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */ 
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: 10em; /* Also needed for space (tweak if needed) */
}

.topbit {
  padding-top: 0.5rem;
}

.bottombit {
  padding-bottom: 0.5rem;
}

.imagestyle2
{
  width: 8em;
}

.highlight
{
  background-color: yellow;
  font-size: 23px;
}
</style>
